var _mask, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsigniavacia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_8193_5478",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 68,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 66,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 62H54.5093L53.2265 65.9979L12.7522 66.2372L11.0328 60.7382L11.2053 61.6474H5L7.11624 56.2606L5 51H6.53872C3.0434 45.8716 1 39.6744 1 33C1 15.3269 15.3269 1 33 1C50.6731 1 65 15.3269 65 33C65 39.2463 63.2104 45.0745 60.1159 50H61L58.6149 55.9289L61 62Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8193_5478)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 62H54.5093L53.2265 65.9979L12.7522 66.2372L11.0328 60.7382L11.2053 61.6474H5L7.11624 56.2606L5 51H6.53872C3.0434 45.8716 1 39.6744 1 33C1 15.3269 15.3269 1 33 1C50.6731 1 65 15.3269 65 33C65 39.2463 63.2104 45.0745 60.1159 50H61L58.6149 55.9289L61 62Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5093 62V61H53.7799L53.5571 61.6945L54.5093 62ZM61 62V63H62.4673L61.9308 61.6343L61 62ZM53.2265 65.9979L53.2324 66.9979L53.9573 66.9936L54.1787 66.3034L53.2265 65.9979ZM12.7522 66.2372L11.7977 66.5356L12.0185 67.2415L12.7581 67.2372L12.7522 66.2372ZM11.0328 60.7382L11.9872 60.4398L10.0503 60.9247L11.0328 60.7382ZM11.2053 61.6474V62.6474H12.4128L12.1877 61.461L11.2053 61.6474ZM5 61.6474L4.06925 61.2818L3.53275 62.6474H5V61.6474ZM7.11624 56.2606L8.047 56.6262L8.19236 56.2562L8.04399 55.8874L7.11624 56.2606ZM5 51V50H3.51983L4.07226 51.3732L5 51ZM6.53872 51V52H8.43045L7.36505 50.4368L6.53872 51ZM60.1159 50L59.2691 49.468L58.3066 51H60.1159V50ZM61 50L61.9277 50.3732L62.4802 49H61V50ZM58.6149 55.9289L57.6872 55.5556L57.5388 55.9245L57.6842 56.2945L58.6149 55.9289ZM54.5093 63H61V61H54.5093V63ZM54.1787 66.3034L55.4615 62.3055L53.5571 61.6945L52.2743 65.6924L54.1787 66.3034ZM12.7581 67.2372L53.2324 66.9979L53.2206 64.9979L12.7463 65.2372L12.7581 67.2372ZM10.0783 61.0367L11.7977 66.5356L13.7066 65.9388L11.9872 60.4398L10.0783 61.0367ZM12.1877 61.461L12.0152 60.5518L10.0503 60.9247L10.2228 61.8338L12.1877 61.461ZM5 62.6474H11.2053V60.6474H5V62.6474ZM6.18549 55.8949L4.06925 61.2818L5.93075 62.0131L8.047 56.6262L6.18549 55.8949ZM4.07226 51.3732L6.1885 56.6338L8.04399 55.8874L5.92774 50.6268L4.07226 51.3732ZM6.53872 50H5V52H6.53872V50ZM0 33C0 39.8816 2.10751 46.274 5.71239 51.5632L7.36505 50.4368C3.97928 45.4691 2 39.4672 2 33H0ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0ZM66 33C66 14.7746 51.2254 0 33 0V2C50.1208 2 64 15.8792 64 33H66ZM60.9626 50.532C64.1543 45.4518 66 39.4399 66 33H64C64 39.0526 62.2664 44.6972 59.2691 49.468L60.9626 50.532ZM61 49H60.1159V51H61V49ZM59.5427 56.3021L61.9277 50.3732L60.0723 49.6268L57.6872 55.5556L59.5427 56.3021ZM61.9308 61.6343L59.5457 55.5632L57.6842 56.2945L60.0692 62.3657L61.9308 61.6343Z",
    fill: "#494949",
    mask: "url(#path-1-outside-1_8193_5478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8193_5478",
    x: 0,
    y: 0,
    width: 66,
    height: 71.2416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8193_5478"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsigniavacia);
export default __webpack_public_path__ + "static/media/insigniavacia.c7a96a07d37c4826513019d0e3941f0e.svg";
export { ForwardRef as ReactComponent };